// Sane
import { Sane } from 'sane-ui'
import Title from './animation/Title'
import * as components from './index'

class LoadMore extends Title {
  constructor ($el, args) {
    super($el, args)

    const q = this.$el.data('q')

    if (q === undefined) {
      return
    }

    const $worskList = $(this.$el.data('controls'))

    if ($worskList.length === 0) {
      return
    }

    this.isLoading = false

    const $parentBlock = this.$el.closest('.block-link')

    this.$el.on(
      'click',
      (event) => {
        event.preventDefault()

        const p = this.$el.data('p')

        if (this.isLoading || p === undefined) {
          return false
        }

        this.isLoading = true

        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: window.app.ajaxUrl,
          data: { action: 'fda', fn: 'get_works', q, p },
          success: (data) => {
            this.isLoading = false
            const $workCards = $(data.markup)
            $worskList.find('.works-list__inner').append($workCards)
            Sane.initComponents(components, $worskList.find('[data-component]'))

            if (data.hasNext === false) {
              $parentBlock.next('.load-more-separator').remove()
              $parentBlock.remove()

              const $afterWorksList = $worskList.next()
              if ($afterWorksList.is('.separator')) {
                if ($afterWorksList.next().length === 0) {
                  $afterWorksList.remove()
                }
              }
              console.log()
            } else {
              this.$el.data('p', data.hasNext)
            }
          },
        })
      }
    )
  }
}

export default LoadMore



// WEBPACK FOOTER //
// ./scripts/components/LoadMore.js